import { AxiosError } from "axios";
import { useCallback } from "react";
import { toast } from "react-toastify";
type HandlersType = {
  [status: number | string]: any;
};

export const useApiError = (handlers?: HandlersType) => {
  const handle400 = ({ msg }: { msg?: string }) => {
    // 400 상태 관련 로직
    toast.error(msg);
  };
  const handle401 = ({ msg }: { msg?: string }) => {
    // 세션 만료 팝업 호출
    toast.error(msg);
  };
  const handle403 = ({ msg }: { msg?: string }) => {
    // 세션 만료 팝업 호출
    toast.error(msg);
  };

  const handle500 = ({ msg }: { msg?: string }) => {
    // 500 상태 관련 로직
    toast.error(msg);
  };

  const handleDefault = ({ msg }: { msg?: string }) => {
    // 기본 에러 처리 로직
    toast.error(msg);
  };

  // 기본적으로 처리될 수 있는 에러 핸들러
  const defaultHandlers: HandlersType = {
    400: {
      default: handle400,
    },
    401: {
      default: handle401,
    },
    403: {
      default: handle403,
    },
    500: {
      default: handle500,
    },
    default: handleDefault,
  };

  const handleError = useCallback(
    (error: any) => {
      const httpStatus = error?.response?.status;
      const errorCode = error?.response?.data?.errorCode;
      const errorMessage = error?.response?.data?.errorMessage ?? "error";
      //   console.log("에러발생!@#", httpStatus, errorCode, errorMessage, error);
      switch (true) {
        case handlers && !!handlers[httpStatus]?.[errorCode]?.[errorMessage]:
          handlers![httpStatus][errorCode][errorMessage]();
          break;

        case handlers && !!handlers[httpStatus]?.[errorCode]:
          handlers![httpStatus][errorCode](error);
          break;

        case handlers && !!handlers[httpStatus]:
          handlers![httpStatus].default(error);
          break;

        case !!defaultHandlers[httpStatus][errorCode]:
          defaultHandlers[httpStatus][errorCode]({ msg: errorMessage });
          break;

        case !!defaultHandlers[httpStatus]:
          defaultHandlers[httpStatus].default({ msg: errorMessage });
          break;

        default:
          defaultHandlers.default();
      }
    },
    [handlers, defaultHandlers]
  );

  return { handleError };
};
